<template>
	<div class="ckeditor"><textarea :id="uid" :value="internalValue" :ckheight="height" :ckwidth="width"></textarea></div>
</template>

<script>
	export default {
		props: {
			value: {
				type: String
			},
			id: {
				type: String,
				default: 'editor'
			},
			height: {
				type: String,
				default: '90px',
			},
			width: {
				type: String,
				default: '100%'
			},
			toolbar: {
				type: Array,
				default: () => [
					['Undo','Redo'],
					['Bold','Italic','Strike'],
					['NumberedList','BulletedList'],
					['Cut','Copy','Paste'],
				]
			},
			language: {
				type: String,
				default: 'en'
			},
			extraplugins: {
				type: String,
				default: ''
			},
			config: {
				type: Object,
				default: () => {}
			},
			simpleImagesDialog: {
				type: Boolean,
				default: false
			}
		},
		data(){
			return {
				uid: this.id + '_' + Math.random().toString(36).substr(2, 9),
				skipChangeEvent: false, 
			}
		},
		computed:{
			internalValue: {
		  	get() { 
					if( !!CKEDITOR.instances[this.uid] && CKEDITOR.instances[this.uid].getData() !== this.value ){
						this.skipChangeEvent = true;
						CKEDITOR.instances[this.uid].setData( this.value );
					}
					return this.value 
				},
		 	 	set(v){
					if( v !== this.value ) {
						this.$emit("input", v);
					}
				}
			},
		},
		mounted () {
			let ckeditorConfig = new ckeditor4Config(this.config);

			const ckeditorId = this.uid
			ckeditorConfig.spawn_ck_textarea(ckeditorId);
			CKEDITOR.instances[ckeditorId].on('change', () => {
				const data = CKEDITOR.instances[ckeditorId].getData()
				if( !this.skipChangeEvent ) {
					this.internalValue = data;
				}
				this.skipChangeEvent = false;
			});

			if( this.simpleImagesDialog ){
				$J(function(){
					CKEDITOR.on( 'dialogDefinition', function( ev ) {
						// Take the dialog name and its definition from the event data.
						const dialogName = ev.data.name;
						const dialogDefinition = ev.data.definition;
				
						// Check if the definition is from the dialog we're
						// interested on (the Link dialog).
						if ( dialogName == 'link' ) {
							// FCKConfig.LinkDlgHideAdvanced = true
							dialogDefinition.removeContents( 'advanced' );
				
							// FCKConfig.LinkDlgHideTarget = true
							dialogDefinition.removeContents( 'target' );
						}
						if ( dialogName == 'image' ) {
							// FCKConfig.ImageDlgHideAdvanced = true	
							dialogDefinition.removeContents( 'advanced' );
							// FCKConfig.ImageDlgHideLink = true
							dialogDefinition.removeContents( 'Link' );
							dialogDefinition.removeContents( 'Upload' );
						}
					});
				});
			}

		},
		destroyed () {
			const ckeditorId = this.uid
			if (CKEDITOR.instances[ckeditorId]) {
				CKEDITOR.instances[ckeditorId].destroy()
			}
		},
		methods: {
			destroy(){
				const ckeditorId = this.uid
				if (CKEDITOR.instances[ckeditorId]) {
					CKEDITOR.instances[ckeditorId].destroy()
				}
			},
			create(){
				const ckeditorId = this.uid

				let ckeditorConfig = new ckeditor4Config(this.config);

				ckeditorConfig.spawn_ck_textarea(ckeditorId);
				CKEDITOR.instances[ckeditorId].on('change', () => {
					let ckeditorData = CKEDITOR.instances[ckeditorId].getData()
					if (ckeditorData !== this.value) {
						this.$emit('input', ckeditorData)
					}
				})

				if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
					CKEDITOR.instances[ckeditorId].setData(this.value)
				}

			}
		}
	}
</script>